import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { MarketInfoService } from 'src/app/services/MarketInfoService.service';
import { RentalService } from 'src/app/services/Rental.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit{
  marketId;
  marketName = "";
  message1 = "";
  message2 = "";
  message3 = "";
  message4 = "";
  imageURL1 = "";
  imageURL2 = "";
  imageURL3 = "";
  vendorTerm = "Vendor";
  companyId:number;
  private subscriptions: Subscription[] = [];
  public loaderIcon: Promise<boolean>;
  HideWRMarketMap: boolean = false;
  SwapORamaCustomChanges: boolean=true;

  constructor(
    private route: ActivatedRoute,
    private marketInfoService: MarketInfoService,
    private operationRentalService: RentalService) {}

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.marketId = params['marketId'];
      this.getMarketDetails();
      this.getWebRentalSettingDashboardSetting();
      this.getWebRentalSetting();
      this.getCustomSettings();
    });
  }

   getCustomSettings() {
    this.operationRentalService.getCustomSettings(this.marketId).subscribe((res: any) => {
      if (res) {
        this.SwapORamaCustomChanges = res.SwapORamaCustomChanges ?? false;
      }
    });
  }

  getMarketDetails() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.marketInfoService.getMarketDetails(this.marketId).subscribe((res: any) => {
      if (res) {
          this.marketName = res.MarketName;
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getWebRentalSetting() {
    const sub = this.marketInfoService.getWebRentalSetting(this.marketId).subscribe((res: any) => {
      if (res) {
        this.HideWRMarketMap = res.HideWRMarketMap;
      }
    }, err => {
    });
    this.subscriptions.push(sub);
  }

  getWebRentalSettingDashboardSetting(){
    this.subscriptions.push(this.marketInfoService.getWebRentalSettingDashboardSetting(this.marketId).subscribe((res: any) => {
      if (res) {
      const timestamp = new Date().getTime();
       this.message1 = res.DashboardMessage1;
       this.message2 = res.DashboardMessage2;
       this.message3 = res.DashboardMessage3;
       this.message4 = res.DashboardMessage4;
       this.imageURL1 = res.DashboardImageURL1 ? res.DashboardImageURL1 + `?timestamp=${timestamp}` : "";
       this.imageURL2 = res.DashboardImageURL2 ? res.DashboardImageURL2 + `?timestamp=${timestamp}` : "";
       this.imageURL3 = res.DashboardImageURL3 ? res.DashboardImageURL3 + `?timestamp=${timestamp}` : "";
       this.vendorTerm = res.VendorTerm;
      }
    }, err => {
    }));
  }

  getFirstVisibleIndex(): number {
    if (this.imageURL1) {
      return 0;
    } else if (this.imageURL2) {
      return 1;
    } else if (this.imageURL3) {
      return 2;
    }
    return -1;
  }

  companyIdSevenMile(companyId){
    this.companyId = companyId
  }
}
